export default `
  <div class="wb-doc-page">
    <div class="doc-main-title">1.總則</div>
    <div class="doc-text doc-pb32">(1).本條款及細則適用及管轄閣下使用由本公司提供之生物認證服務。</div>
    <div class="doc-text doc-pb32">(2).閣下透過啟動或使用生物認證服務，即表示閣下接受並同意本條款。若閣下不接受本條款，則請勿啟動或使用生物認證服務。</div>
    <div class="doc-text">(3).生物認證服務是本公司所提供的服務的一部分，它是代替安全編碼驗證的另一途徑，以核實閣下的身份，達到向本公司發出指示和授權交易。</div>

    <div class="doc-main-title">2.定義和解釋</div>
    <div class="doc-text doc-pb32">(1).除非有相反的說明，客戶協議書中定義的術語在本條款中具有相同的含義。</div>
    <div class="doc-text doc-pb32">(2).在本條款中，除非上下文另有要求，下列術語應具有以下含義：</div>
    <div class="doc-text doc-pb32">I.“應用程式”：指閣下可以在任何移動設備下載的名為【“盈宝证券”】（不時更新）的移動應用程式。並通過該等移動應用程式使用本公司的服務；</div>
    <div class="doc-text doc-pb32">II.“生物認證服務”：指本公司根據本條款提供的身份認證功能。它使閣下能夠在通過應用程式向本公司發出指示時以生物認證憑證驗證閣下的身份；</div>
    <div class="doc-text doc-pb32">III.“生物認證憑證”：指在認可移動設備上使用生物識別憑據（包括 ：指紋 碼或面部測繪圖或其他生物特征）的身份認證功能；</div>
    <div class="doc-text doc-pb32">IV.“客戶協議書”：指經不時修訂的《客戶協議書》、開戶表格和任何其他適用於閣下的帳戶的協議或條款及細則；</div>
    <div class="doc-text doc-pb32">V.“認可移動設備”：指內置蘋果或安卓的移動設備以及本公司不時指定可使用於生物認證服務的其他電子設備，包括該等移動設備或電子設備運行的操作系統或軟件。</div>
    <div class="doc-text doc-pb32">VI.“安全編碼”：指閣下設定的用於發出指示和授權交易的密碼；</div>
    <div class="doc-text">(3).在本條款中，單數詞含義包括複數詞，反之亦然。而單一性別的詞包括所有性別。除非另有說明，對條文的提述指本條款及細則中的條文。</div>

    <div class="doc-main-title">3.客戶協議書的補充</div>
    <div class="doc-text">本條款及細則乃附加於客戶協議書之上，應與客戶協議書一起閱讀。就生物認證服務而言，如本條款及細則的條文與客戶協議書的條文有任何不一致，概以本條款及細則的條文為準。</div>

    <div class="doc-main-title">4.生物認證服務</div>
    <div class="doc-text doc-pb32">(1).若要啟動生物認證服務，閣下必須啟動認可移動設備上的生物認證傳感器模組，並執行本公司不時指定的步驟以完成注冊。注冊成功後，閣下就可以在應用程式中使用生物認證憑證代替安全編碼驗證身份，並向本公司發出指示。</div>
    <div class="doc-text doc-pb32">(2).在認可移動設備上啟動生物認證服務後，閣下仍然可以選擇在應用程式中使用安全編碼向本公司發出指示。</div>
    <div class="doc-text doc-pb32">(3).閣下可以隨時以本公司不時指定的步驟取消生物認證服務。該服務被取消後，閣下仍可以繼續在應用程式中使用安全編碼向本公司發出指示。</div>
    <div class="doc-text">(4).本公司有權隨時指定或更改生物認證服務的範圍和功能，而無須事先通知閣下。</div>

    <div class="doc-main-title">5.閣下的確認及責任</div>
    <div class="doc-text doc-pb32">(1).閣下理解並授權本公司為提供生物認證服務之目的，應用程式將通過連接閣下的認可移動設備上的生物認證傳感器模組驗證身份。就此目的而言，閣下同意進行身份認證過程，並同意本公司訪問和使用通過生物認證傳感器模組獲得的資訊。本公司不會存儲閣下的生物認證憑證。</div>

    <div class="doc-text doc-pb32">(2).在本條款中，除非上下文另有要求，下列術語應具有以下含義：</div>
    <div class="doc-text doc-pb32">I.是應用程式的有效用戶；</div>
    <div class="doc-text doc-pb32">II.使用閣下的認可移動設備安裝應用程式；</div>
    <div class="doc-text doc-pb32">III.在閣下的認可移動設備上啟動生物認證傳感器模組，並登記閣下最少一個生物認證憑證；</div>
    <div class="doc-text doc-pb32">IV.（i）在閣下所使用的每部新的認可移動設備；以及（ii）重新安裝應用程式或刪除認可移動設備內的本地數據之後，閣下須重新啟動生物認證服務，並再次同意本條款。</div>

    <div class="doc-text doc-pb32">(3).閣下完全明白並同意，在認可移動設備上成功注冊生物認證服務後：</div>
    <div class="doc-text doc-pb32">I.每次應用程式檢測到該設備上使用生物認證憑證發出與交易相關的指示時，閣下都被視為已經指示本公司執行該交易；</div>
    <div class="doc-text doc-pb32">II.閣下必須確保認可流動設備只儲存閣下的生物識別憑據。若閣下存儲任何其他人的生物認證憑證或允許任何其他人的生物認證憑證存儲在該設備上，閣下應對所有指示和由此產生的交易負責。所有該等交易將被視為得到閣下授權，並將根據客戶協議書的條款，包括關於閣下在欺詐或重大過失情況下進行的未授權交易的責任的條款，對閣下具有約束力。</div>

    <div class="doc-text doc-pb32">(4).閣下應采取所有合理的保安措施，防止閣下的認可移動設備、生物認證憑證和生物認證服務遭未經授權使用或用作欺詐用途。這些預防措施包括（但不限於）:</div>
    <div class="doc-text doc-pb32">I.采取合理的預防措施，妥善保管並防止閣下的認可移動設備、生物認證憑證和生物認證服務遺失或用作欺詐用途。閣下應遵守本公司不時提供的有關使用生物認證服務的安全建議；</div>
    <div class="doc-text doc-pb32">II.閣下不得在流動設備或操作系統供貨商支持或保修的配置範圍以外，經過修改的流動設備或操作系統上使用應用程式或生物認證服務。該等設備包括軟件保護被破解 （jailbroken）或已開放根目錄權限（rooted）的設備。軟件保護被破解或已開放根目錄權限的設備是指在未經移動服務提供商和手機制造商批準而自行解除其所設限製的設備。在軟件保護被破解或已開放根目錄權限的設備上使用應用程式或生物認證服務，可能會令保安受損，並導致欺詐或未經授權的交易。在軟件保護被破解或已開放根目錄權限的設備上使用應用程式或生物認證服務，其風險完全由閣下承擔，本公司不會對閣下因此遭受或招致的任何損失或損害，或任何其他直接或間接後果承擔責任；</div>
    <div class="doc-text doc-pb32">III.若閣下：（i）有雙胞胎兄弟姐妹；或（ii）處於青春期（此時閣下的面部特征可能正處於快速發育階段），建議閣下在應用程式中使用安全編碼向本公司發出指示；</div>
    <div class="doc-text doc-pb32">IV.避免在認可移動設備上采取任何可能危及在生物認證服務中使用生物認證憑證的安全性的設定，如停止使用任何功能（例如：在面部識別功能中停止使用能夠感知用戶注視的功能）；</div>
    <div class="doc-text doc-pb32">V.若閣下知悉或懷疑閣下的認可移動設備、生物認證憑證或生物認證服務遭未經授權使用，閣下應在合適可行下盡快撥打本公司的客戶服務熱線通知本公司。在合適的情況下，本公司可能會要求閣下更改安全編碼或任何密碼、重新登記生物認證憑證或停止使用生物認證服務。</div>

    <div class="doc-text doc-pb32">(5).由本公司收到的所有透過閣下身份生物認證服務驗證發出的指示，均對閣下具有約束力。閣下須根據客戶協議書的規定對所有該等指示和所有由此產生的交易承擔責任。</div>
    <div class="doc-text">(6).若閣下允許任何第三方使用閣下的認可移動設備，或未能遵守閣下在本合約條款下的義務或任何安全措施，以及本公司不時提供的安全資訊和/或其他相關文件，閣下須對所有損失（包括但不限於因任何未經授權交易而產生的損失）承擔責任。</div>

    <div class="doc-main-title">6.本公司的責任限製</div>
    <div class="doc-text doc-pb32">(1).生物認證服務以“按現狀”和“按現有可予提供”的原則向閣下提供。本公司不保證生物認證服務在任何時候均可使用，亦不保證生物認證服務可與任何電子設備、軟件、系統或本公司不時提供的其他服務兼容。</div>
    <div class="doc-text doc-pb32">(2).閣下的認可移動設備上的生物認證傳感器模組並非由本公司提供。本公司亦不對生物認證傳感器技術負責。本公司不作出任何種類的明示或默示保證，包括對質量、準確性或性能、可商售性、特定目的適用性、所有權或不侵權的任何保證。</div>
    <div class="doc-text doc-pb32">(3).就閣下使用或無法使用生物認證服務而遭受或招致的任何種類的損失、損害或費用而言，除非該等損失、損害或費用完全和直接由本公司或本公司的員工或代理人的重大疏忽或故意失責造成，本公司概不負責。</div>
    <div class="doc-text">(4).在任何情況下，就任何間接的、特別的、附帶的、相應的、懲罰性的或懲戒性的損失或損害，本公司概不負責，包括利潤損失、業務中斷引致之損失，或閣下的認可移動設備內任何程式或數據的損失。</div>

    <div class="doc-main-title">7.生物認證服務的修改、暫停和終止</div>
    <div class="doc-text">在本公司合理地認為必要或適宜的情況下，本公司有權隨時修改、暫停或終止生物認證服務，而無需事先通知閣下或給予閣下任何理由。該等情況包括（但不限於）實際或涉嫌違反安全規定。</div>

    <div class="doc-main-title">8.其他事項</div>
    <div class="doc-text">Apple是蘋果公司在美國和其他司法管轄區注冊的商標。</div>
    <div class="doc-text doc-pb32">Android是谷歌公司的商標。</div>
  </div>
`
